<template>
  <div class="application_wrap">
    <h3>서울특별시 시각장애인 플러스 지원센터 이용 신청/변경 요청</h3>

    <div class="selectClass">
      <h4>장애 유형을 선택해주세요</h4>
    </div>

    <div class="selectClass">
      <button class="class-btn vision-btn" @click="redirectTo('vision')">시각</button>
      <button class="class-btn" @click="redirectTo('kidney')">신장</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectTo(disabilityType) {
      if (disabilityType === 'vision') {
        this.$router.push('/m/member/registHC'); // 시각장애인 등록 페이지로 이동
      } else if (disabilityType === 'kidney') {
        this.$router.push('/m/member/regist'); // 신장장애인 등록 페이지로 이동
      }
    }
  }
}
</script>

<style scoped>
.selectClass {
  text-align: center;
  padding: 20px;
}

.class-btn {
  height: 3em;
  width: 4em;
  display: inline-block;
  padding: 0;
  font-size: 4rem;
  font-weight: bold;
  background-color: lightgray;
  border: 0.125rem solid transparent;
  border-radius: 0.625rem;
  cursor: pointer;
  margin: 0 0.9375rem 1.25rem 1.25rem;
  transition: 0.3s;
}

.class-btn:hover {
  background-color: #f0f0f0;
}

.vision-btn {
  color: yellow !important;
  background-color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/member/RegistClass.vue